module.exports = __webpack_public_path__ + "static/media/MidwestTimes-devicecomp-min@2x.b8420720.webp";